import { Component } from 'src/utils';
import template from './nav-login.html';
import info from './../../../images/question.png';
import dscCard from './../../../images/WBU-DSC-card.jpg';
import houseIcon from './../../../images/house-icon.png';
import searchIcon from './../../../images/search.png';
import higlightedmarkerIcon from './../../../images/wbu-pointer.png';
import markerIcon from './../../../images/wbu-map-pointer.png';
@Component({
  controllerAs: 'login',
  template
})

export default class navlogin {

  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    '$cookies',
    'spinnerService',
    'authService',
    'toaster',
    '$window',
    'orderService',
    '$uibModal',
    '$q',
    'APP'
  ];

  constructor($rootScope, $scope, $ngRedux, $state, $stateParams, $cookies, $spinner, authService, $toaster, $window, $order, $uibModal, $q, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$rootScope = $rootScope;
    this.$cookies = $cookies;
    this.$state = $state;
    this.toaster = $toaster;
    this.storeName = $stateParams.storeName;
    this.authService = authService;
    this.$window = $window;
    this.$spinner = $spinner;
    this.$order = $order;
    this.info = info;
    this.$uibModal = $uibModal;
    this.dscCard = dscCard;
    this.searchIcon = searchIcon;
    this.markerIcon = markerIcon;
    this.higlightedmarkerIcon = higlightedmarkerIcon;
    this.$q = $q;
    this.$stateParams = $stateParams;
    this.APP = APP;
    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.storeName = $stateParams.storeName;
    }
    else {
      this.storeName = authService.getGuestStoreDetail().storeName;
    }
    if ($stateParams.storeName) {
      $spinner.show('appSpinner');
      authService.getStoreDetail($stateParams.storeName)
        .finally(() => $spinner.hide('appSpinner'));
    }
    $scope.$on('$destroy', disconnect);
    
  }


  mapState(state) {
    return {
      store: state.auth.storeDetail,
      storesList: state.auth.storesList
    };
  }

  isScreenSmall() {
    if (this.$window.innerHeight < 300) return true;
  }

  openStoreSelector() {
    this.$rootScope.$emit('onStoreSelection');
    let msg = 'Text';
    var $ctrl;
    $ctrl = this;
    $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
    $ctrl.markerIcon = this.markerIcon;
    this.$uibModal.open({
      size: 'lg',
      template:
        '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' +
        '<div class="row">' +
        '<div class="col-md-3 p-l-0 p-r-0">' +
        '<div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div style="padding: 0;">' +
        '<form class="input-group" style="text-align: center;padding: 3px;">' +
        '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' +
        '<span class="input-group-btn"  >' +
        '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' +
        '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' +
        '</button>' +
        '</span>' +
        '</form>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<br/><div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' +
        ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' +
        '<div  class="row store-nm-div">' +
        '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' +
        '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' +
        '</div> ' +
        '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' +
        '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' +
        '<span  class="search-span">Shop Now</span>' +
        '</button>' +
        '</div>' +
        '</div>' +

        '</div> </div>' +
        '<div class="col-md-12 p-r-0 p-l-0 closest-div">' +
        '<div class="col-md-12 p-r-0 p-l-0">' +
        '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' +
        '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' +

        '</div>' +
        '</div>' +
        '</div>' +


        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' +
        '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' +
        '<info-window id="storeInfo" max-width="200">' +
        '<div ng-non-bindable="">' +
        '<div class="scrollFix">' +
        '<div class="row">' +
        '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' +
        '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' +
        '</div>' +
        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
        //  '<div class="col-xs-12">'+
        //    '<div class="m-b-0">'+
        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
        //    '<span>{{storeObj.addressLine1}}<br />'+
        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
        //    '</div>'+
        //  '</div>'+
        '</div>' +
        '</div>' +
        '</div>' +
        '</info-window>' +
        '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' +
        '</map>' +
        '</div>',
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap',
        function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
          this.$state = $state;
          $scope.selectedStoreClass = "selectedStore";
          $scope.notSelectedClass = "";
          $scope.lat = '37.274053';
          $scope.long = '-103.535156';
          $scope.zoom = 4;
          $scope.count = 5;
          $scope.noStoresFound = false;
          $scope.stores = [];
          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
          $scope.markerIcon = $ctrl.markerIcon;
          $scope.notMoreThanone = 0;
          NgMap.getMap()
            .then(map => {
              console.log('map', map);
              $scope.map = map;
            });




          $scope.showStoreInfo = (e, index, storeObj) => {
            console.log('storeObj', storeObj);
            $scope.changeStyle();
            $scope.selectedStore = storeObj.storeURLName;
            $scope.storeIndex = index + 1;

            $scope.storeObj = storeObj;
            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
          };

          $scope.ok = () => {
            //  $uibModalInstance.close();
            $scope.count = 5;
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": 5

            };

            // THough if its a SEO site, Hard coding isSEORequest to false, in order to not to display the store which needs to be redirected while registering.
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            // data.isSEORequest = false;
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              $scope.lat = $scope.stores[0].lat;
              $scope.long = $scope.stores[0].lng;
              $scope.zoom = 4;
              $scope.noStoresFound = false;
              console.log(success.data);
              if ($scope.stores.length == 0) {
                $scope.noStoresFound = true;
              }

              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            }, error => {
              $scope.noStoresFound = true;
            });
          };

          $scope.loadMore = () => {
            //  $uibModalInstance.close();
            if ($scope.count) {
              $scope.count = $scope.count + 5;
            } else {
              $scope.count = 10;
            }
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": $scope.count

            };
             // THough if its a SEO site, Hard coding isSEORequest to false, in order to not to display the store which needs to be redirected while registering.
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            // data.isSEORequest = false;
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              console.log(success.data);
              // this.test();
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            });
          };

          $scope.cancel = () => {

            $uibModalInstance.close();
          };

          $scope.selectStore = (index, store, item) => {
            // $scope.changeStyle();

            $scope.showStoreInfo(item, index, store);
            $scope.selectedStore = item;
            $scope.storeObj = store;
            $scope.lat = store.lat;
            $scope.long = store.lng;
          };

          $scope.changeStyle = () => {
            console.log("$scope.notMoreThanone", $scope.notMoreThanone);
            if ($scope.notMoreThanone < 2) {
              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
              // var selectorText = '.gm-style-iw-a::after';
              var selectorText = '.gm-style .gm-style-iw-c';
              var replace_infowindow = 'replace-infowindow';
              var arrow_selector = '.gm-style-iw-a::after';
              var replace_arrow_selector = 'replace_arrow_a::after';
              var theRules = [];
              // console.log(document.styleSheets[29].cssRules.length);
              for (var i = 0; i < document.styleSheets.length; i++) {
                try {
                  if (document.styleSheets[i].cssRules) {
                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
                      // console.log(document.styleSheets[i].cssRules[j].selectorText);
                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText
                        || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow
                        || document.styleSheets[i].cssRules[j].selectorText == arrow_selector
                        || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                        console.log("Inside:", document.styleSheets[i].cssRules[j].selectorText, " JValue :", j);
                        // document.styleSheets[i].cssRules[j].selectorText="gm-style-iw-t::after";
                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
                        }
                        console.log("Inside:", document.styleSheets[i].cssRules[j]);
                      }
                    }
                  }
                } catch (e) {
                  console.log("Some Error");
                }

              }
              // else if (document.styleSheets[0].rules) {
              //     theRules = document.styleSheets[0].rules;
              // }
              // console.log("theRules : ", theRules);
              // for (var n in theRules)
              // {
              //     cosole.log("Rules :",theRules[n].selectorText);
              //     if (theRules[n].selectorText == selectorText)   {
              //         theRules[n].style.color = 'blue';
              //     }
              // }
            } else {
              console.log("Else part :");
            }
            $scope.notMoreThanone = $scope.notMoreThanone + 1;
          };

          $scope.goToProductPage = (store, item) => {
            console.log($stateParams);
            $stateParams.storeName = item;
            $window.location.href = '/' + $stateParams.storeName + '/' +
              $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
            // $uibModalInstance.close();
            //  this.$state.go('signup', {
            //    storeName: item
            //  });
          };

          $scope.formatMobileNum = (num, format) => {

            var unFormattedNum = num;
            var position1 = 0;
            var position2 = 4;
            var position3 = 9;
            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
            return FormattedNum;
          };

          $scope.goToSignUp = (store, item) => {
            console.log($stateParams);
            // $stateParams.storeName = item;
            // $window.location.href = '/'+$stateParams.storeName + '/' +
            // $stateParams.categoryId + '/'+ $stateParams.subCategoryId + '/' + $stateParams.productId;

            $uibModalInstance.close();
            this.$state.go('signup', {
              storeName: item
            });
          };
        }
      ]

    });
  }
    
  submit(form) {
    if (form.$invalid) {
      return;
    }
    var isCancel = false;
    form.error = {};
    this.$spinner.show('appSpinner');
    this.authService.registerLogin({
      email: this.email,
      password: this.password
    })
      .then(
      success => {
        this.$spinner.hide('appSpinner');
        this.$rootScope.$emit('loginFromPopup', success);
      },
      error => {
        this.$spinner.hide('appSpinner');
        if (error.data.errorCode === 621) {
          this.noEmailError = true;
          this.$state.go('inactive');
        }
        else {
          this.noEmailError = false;
          form.error = error.data;
        }
      });
  }

  togglePassword(passwordIdTag,togglei) {
    var x = document.getElementById(passwordIdTag);
    var y = document.getElementById(togglei);
      console.log("Password tag ", x);
    if (x.type === "password") {
      x.type = "text";
      y.classList.remove('fa-eye-slash');
      y.classList.add('fa-eye');
    } else {
      x.type = "password";
      y.classList.remove('fa-eye');
      y.classList.add('fa-eye-slash');
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/nav-login/nav-login.js